export function renderHUD(uiRoot: HTMLElement, text: string) {
  const elId = "hud";
  let el = document.getElementById(elId);
  if (!el) {
    el = document.createElement("div");
    el.id = elId;
    el.className = "hud";
    el.innerHTML = `<div class="badge"></div>`;
    uiRoot.appendChild(el);
  }
  const badge = el.querySelector(".badge") as HTMLDivElement;
  badge.textContent = text;
}

export function clearHUD() {
  document.getElementById("hud")?.remove();
}
